import ADIColors from "@NA/Utils/ADIColors";
import translate from "@insite/client-framework/Translate";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import { IconWrapper } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Typography, { } from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps {
    quoteDetails: OrderModel | undefined;
    isNonReturnableModalOpen: boolean;
    closeModalNonReturnable: () => void;
    AgreeAndContinueCheckout: (url: string, customerOrderId: string) => void;
}

type Props = OwnProps;

export interface ADIRfqPopupNonReturnableModalStyles {
    nonReturnableModal?: ModalPresentationProps;
    titleTypography?: InjectableCss;
    tableContainer?: GridContainerProps;
    nonReturnableTableHeader?: GridItemProps;
    nonReturnableTableBody?: GridItemProps;
    nonReturnableTableLi?: GridItemProps;
    titleTypographyAcknowledgement?: InjectableCss;
    policyContainer?: GridContainerProps;
    policyTitle?: InjectableCss;
    policyPara?: InjectableCss;
    actionContainer?: GridContainerProps;
    actionContainerGridItem?: GridItemProps;
    agreeButton?: ButtonPresentationProps;
    removeItemsLink?: LinkPresentationProps;
}

export const adiRfqPopupNonReturnableModalStyles: ADIRfqPopupNonReturnableModalStyles = {
    actionContainer: {
        offsetCss: css`
            width: 100% !important;
            margin: auto;
        `,
    },
    actionContainerGridItem: {
        css: css`
            flex-direction: column;
            flex-basis: 100%;
            max-width: 100%;
            align-items: center;
        `,
    },
    agreeButton: {
        css: css`
            width: auto;
            margin-bottom: 1rem;
            height: 40px;
            background-color: ${getColor("primary")};
            border: none;
            font-weight: 800;
            padding: 5px 10px !important;
            box-shadow: inset 0 -4px 0 0 ${ADIColors.blue1};
        `,
    },
    removeItemsLink: {
        css: css`
            font-size: 14px;
            font-weight: bold;
        `,
    },
    policyTitle: {
        css: css`
            color: ${getColor("secondary")};
            justify-content: center;
            font-weight: 900;
            font-stretch: normal;
            font-style: normal;
            line-height: 36px;
            letter-spacing: normal;
            color: ${ADIColors.darkBlue1};
            border: 0;
            margin-top: 0;
            padding-bottom: 0;
            font-size: 20px !important;
            text-align: center;
            margin-bottom: 15px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        text-align: center;
                    `,
                    css`
                        text-align: center;
                    `,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    policyPara: {
        css: css`
            font-size: 12px;
            display: inline;
            margin-bottom: 1rem !important;
            padding: 0px 15px;
        `,
    },
    policyContainer: {
        offsetCss: css`
            width: 100% !important;
            margin: auto;
            border: 1px solid ${getColor("common.border")};
            max-height: 209px;
            overflow-y: scroll;
            margin-bottom: 20px;
            &::-webkit-scrollbar {
                width: 8px;
            }

            &::-webkit-scrollbar-track {
                background: ${getColor("common.background")};
            }

            &::-webkit-scrollbar-thumb {
                background-color: ${getColor("text.accent")};
                border-radius: 7px;
            }
            > * {
                flex-basis: 100%;
                max-width: 100%;
            }
        `,
    },
    titleTypographyAcknowledgement: {
        css: css`
            margin: 1rem 0rem;
            line-height: inherit;
            font-size: 18px;
            line-height: 24px;
            color: ${getColor("text.main")};
            margin-bottom: 9px;
            font-weight: 600;
        `,
    },
    nonReturnableTableLi: {
        css: css`
            flex-basis: 100%;
            max-width: 100%;
            padding: 10px 20px;
            align-items: center;
            font-size: 16px;
            -webkit-text-size-adjust:100%;
            &:nth-child(even) {
                background: ${getColor("common.accent")};
            }
            &:nth-child(odd) {
                background: ${getColor("text.disabled")};
            }
            > ${TypographyStyle}:first-child {
                width: 20%;
            }
            > ${TypographyStyle}:nth-child(2) {
                width: 25%;
            }
            > ${TypographyStyle}:last-child {
                width: 55%;
            }
        `,
    },
    nonReturnableTableBody: {
        css: css`
            border: 1px solid ${getColor("common.border")};
        `,
    },
    nonReturnableTableHeader: {
        css: css`
            -webkit-text-size-adjust:100%;
            > ${TypographyStyle}:first-child {
                width: 20%;
                font-size: 1rem;
                font-weight: bold;
            }
            > ${TypographyStyle}:nth-child(2) {
                width: 25%;
                font-size: 1rem;
                font-weight: bold;
            }
            > ${TypographyStyle}:last-child {
                width: 55%;
                font-size: 1rem;
                font-weight: bold;
            }
        `,
    },
    tableContainer: {
        css: css`
            overflow: auto;
        `,
        offsetCss: css`
            margin: auto;
            flex-basis: 100%;
            max-width: 100%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 1470px !important;
                        max-width: 1470px;
                    `,
                    css`
                        width: 1470px !important;
                        max-width: 1470px;
                    `,
                    null,
                    null,
                    null,
                ])}
            > ${GridItemStyle}:first-child {
                flex-basis: 100%;
                max-width: 100%;
                padding: 10px 20px;
            }
            > ${GridItemStyle}:last-child {
                flex-basis: 100%;
                max-width: 100%;
                flex-direction: column;
                padding: 0px;
                align-items: unset;
            }
        `,
    },
    titleTypography: {
        css: css`
            line-height: inherit;
            font-size: 18px;
            line-height: 24px;
            color: ${getColor("text.main")};
            margin-bottom: 9px;
            font-weight: 600;
        `,
    },
    nonReturnableModal: {
        headlineTypographyProps: {
            variant: "h2",
            css: css`
                font-size: 34px;
                font-weight: 900;
                font-stretch: normal;
                font-style: normal;
                line-height: 36px;
                letter-spacing: normal;
                color: ${ADIColors.darkBlue1};
                border: 0;
                margin-top: 0;
                margin-bottom: 10px;
                padding-bottom: 0;
            `,
        },

        closeButtonProps: {
            css: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 0px;
                        `,
                        css`
                            padding: 0px;
                        `,
                        null,
                        null,
                        null,
                    ])}
                &:hover {
                    background: transparent;
                    border-color: transparent;
                }
                &:focus {
                    outline: none;
                }
                > ${IconWrapper} {
                    color: ${getColor("primary")};
                    width: 35px;
                    height: 35px;
                    > svg {
                        width: 35px;
                        height: 35px;
                        stroke-width: 1px;
                    }
                }
            `,
        },
        cssOverrides: {
            modalBody: css`
                padding: 15px 10px 30px 25px;
                border-radius: 7px;
                overflow: hidden;
            `,

            modalContent: css`
                padding: 0px 10px 0px 0px;
                overflow: hidden auto;
                &::-webkit-scrollbar {
                    width: 8px;
                }

                &::-webkit-scrollbar-track {
                    background: ${getColor("common.accent")};
                }

                &::-webkit-scrollbar-thumb {
                    background-color: ${ADIColors.lightblue2};
                    border-radius: 7px;
                }
            `,
            modalTitle: css`
                border: unset;
                padding: 0px 10px 0px 0px;
            `,
        },
    },
};

const styles = adiRfqPopupNonReturnableModalStyles;

const ADIRfqPopupNonReturnableModal: FC<Props> = ({
    isNonReturnableModalOpen,
    closeModalNonReturnable,
    quoteDetails,
    AgreeAndContinueCheckout,
}) => {
    return (
        <Modal
            isOpen={isNonReturnableModalOpen}
            handleClose={closeModalNonReturnable}
            headline="Non Returnable Item(s)"
            sizeVariant="large"
            {...styles.nonReturnableModal}
        >
            <Typography variant="h3" {...styles.titleTypography}>
                {translate("The following item(s) on your order are non returnable:")}
            </Typography>
            <GridContainer {...styles.tableContainer}>
                <GridItem {...styles.nonReturnableTableHeader}>
                    <Typography> {translate("ADI Part #")}</Typography>
                    <Typography>{translate("Manufacturer Part #")}</Typography>
                    <Typography>{translate("Description")}</Typography>
                </GridItem>
                <GridItem {...styles.nonReturnableTableBody}>
                    {quoteDetails?.invoiceOrderLines[0]?.invoiceOrderLines?.map((item: any, index: number) => {
                        return (
                            <>
                                {(item?.properties?.nonReturnable === 'N') && (item?.qtyOrdered >0 ) && <GridItem
                                    as="li"
                                    {...styles.nonReturnableTableLi}
                                    key={`non-Returnable-Item${index}`}
                                >
                                    <Typography>{item?.productErpNumber}</Typography>
                                    <Typography>{item?.properties['modelNumber']}</Typography>
                                    <Typography>{item?.properties['longDescription']}</Typography>
                                </GridItem>}
                            </>
                        );
                    })}
                </GridItem>
            </GridContainer>
            <Typography variant="h3" {...styles.titleTypographyAcknowledgement}>
                {translate("Please review the Custom Order Product Acknowledgement")}
            </Typography>
            <GridContainer {...styles.policyContainer}>
                <GridItem as="h2" {...styles.policyTitle}>
                    {translate("Non-Returnable Product Acknowledgement Form")}
                </GridItem>
                <GridItem as="p" {...styles.policyPara}>
                    The undersigned acknowledges that this product is non-returnable. By clicking accept, you agree
                    that this order for products may not be cancelled and is non-returnable.
                </GridItem>
                <GridItem as="p" {...styles.policyPara}>
                    <strong>
                        You acknowledge that ADI makes no warranty whatsoever regarding such products and that ADI
                        provides product AS IS.
                    </strong>
                    &nbsp; ADI will make available Vendor’s repair/return policy for defective product, to the
                    extent applicable.
                    <strong>
                        &nbsp; You are required to accept full responsibility for and take delivery of all
                        non-returnable product.
                    </strong>
                </GridItem>
                <GridItem as="p" {...styles.policyPara}>
                    In the event you believe product is defective, ADI will assist in obtaining an RMA from the
                    Vendor if required, to enable Vendor to evaluate your claim, or facilitate return or repair of
                    product in accordance with Vendor's warranty or policies.&nbsp;
                    <strong>
                        However, ADI takes no responsibility or liability for defective product should the Vendor
                        deem that product is not covered by warranty.
                    </strong>
                </GridItem>
                <GridItem as="p" {...styles.policyPara}>
                    ADI reserves the right to bill for any non-returnable products that either have not been picked
                    up or accepted for delivery.
                </GridItem>
                <GridItem as="p" {...styles.policyPara}>
                    By clicking accept on this form, you agree to the terms contained herein.
                </GridItem>
                <GridItem as="p" {...styles.policyPara}>
                    <strong>
                        Please note that if the non-returnable product is not picked up or accepted for delivery
                        your account will be billed for the full amount of the product.
                    </strong>
                </GridItem>
            </GridContainer>
            <GridContainer {...styles.actionContainer}>
                <GridItem {...styles.actionContainerGridItem}>
                    <Button
                        {...styles.agreeButton}
                        onClick={() => AgreeAndContinueCheckout('/Checkout/ReviewAndPay?cartId=', `${quoteDetails?.insiteCustomerOrderId}`)}
                    >
                        {translate("Agree and Continue Checkout")}
                    </Button>
                    <Link {...styles.removeItemsLink}
                        onClick={closeModalNonReturnable}
                    >
                        {translate("Cancel")}
                    </Link>
                </GridItem>
            </GridContainer>
        </Modal>
    )
};

export default ADIRfqPopupNonReturnableModal;
